"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRequest = exports.XhrRequest = void 0;
exports.fullUrl = fullUrl;
var Emitter_1 = __importDefault(require("licia/Emitter"));
var isStr_1 = __importDefault(require("licia/isStr"));
var last_1 = __importDefault(require("licia/last"));
var Url_1 = __importDefault(require("licia/Url"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var trim_1 = __importDefault(require("licia/trim"));
var now_1 = __importDefault(require("licia/now"));
var each_1 = __importDefault(require("licia/each"));
var startWith_1 = __importDefault(require("licia/startWith"));
var toNum_1 = __importDefault(require("licia/toNum"));
var util_1 = require("./util");
var XhrRequest = (function (_super) {
    __extends(XhrRequest, _super);
    function XhrRequest(xhr, method, url) {
        var _this = _super.call(this) || this;
        _this.xhr = xhr;
        _this.reqHeaders = {};
        _this.method = method;
        _this.url = fullUrl(url);
        _this.id = (0, util_1.createId)();
        xhr.addEventListener('readystatechange', function () {
            if (xhr.readyState === 2) {
                _this.handleHeadersReceived();
            }
            else if (xhr.readyState === 4) {
                if (xhr.status === 0) {
                    _this.handleError();
                }
                else {
                    _this.handleDone();
                }
            }
        });
        return _this;
    }
    XhrRequest.prototype.toJSON = function () {
        return {
            method: this.method,
            url: this.url,
            id: this.id,
        };
    };
    XhrRequest.prototype.handleSend = function (data) {
        if (!(0, isStr_1.default)(data))
            data = '';
        data = {
            name: getFileName(this.url),
            url: this.url,
            data: data,
            time: (0, now_1.default)(),
            reqHeaders: this.reqHeaders,
            method: this.method,
        };
        if (!(0, isEmpty_1.default)(this.reqHeaders)) {
            data.reqHeaders = this.reqHeaders;
        }
        this.emit('send', this.id, data);
    };
    XhrRequest.prototype.handleReqHeadersSet = function (key, val) {
        if (key && val) {
            this.reqHeaders[key] = val;
        }
    };
    XhrRequest.prototype.handleHeadersReceived = function () {
        var xhr = this.xhr;
        var type = getType(xhr.getResponseHeader('Content-Type') || '');
        this.emit('headersReceived', this.id, {
            type: type.type,
            subType: type.subType,
            size: getSize(xhr, true, this.url),
            time: (0, now_1.default)(),
            resHeaders: getHeaders(xhr),
        });
    };
    XhrRequest.prototype.handleDone = function () {
        var _this = this;
        var xhr = this.xhr;
        var resType = xhr.responseType;
        var resTxt = '';
        var update = function () {
            _this.emit('done', _this.id, {
                status: xhr.status,
                size: getSize(xhr, false, _this.url),
                time: (0, now_1.default)(),
                resTxt: resTxt,
            });
        };
        var type = getType(xhr.getResponseHeader('Content-Type') || '');
        if (resType === 'blob' &&
            (type.type === 'text' ||
                type.subType === 'javascript' ||
                type.subType === 'json')) {
            readBlobAsText(xhr.response, function (err, result) {
                if (result)
                    resTxt = result;
                update();
            });
        }
        else {
            if (resType === '' || resType === 'text')
                resTxt = xhr.responseText;
            if (resType === 'json')
                resTxt = JSON.stringify(xhr.response);
            update();
        }
    };
    XhrRequest.prototype.handleError = function () {
        this.emit('error', this.id, {
            errorText: 'Network error',
            time: (0, now_1.default)(),
        });
    };
    return XhrRequest;
}(Emitter_1.default));
exports.XhrRequest = XhrRequest;
var FetchRequest = (function (_super) {
    __extends(FetchRequest, _super);
    function FetchRequest(input, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        var isRequest = input instanceof window.Request;
        var url = isRequest ? input.url : input;
        _this.url = fullUrl(url);
        _this.id = (0, util_1.createId)();
        _this.options = options;
        _this.reqHeaders = options.headers || (isRequest ? input.headers : {});
        _this.method = options.method || (isRequest ? input.method : 'GET');
        return _this;
    }
    FetchRequest.prototype.send = function (fetchResult) {
        var _this = this;
        var options = this.options;
        var data = (0, isStr_1.default)(options.body) ? options.body : '';
        this.emit('send', this.id, {
            name: getFileName(this.url),
            url: this.url,
            data: data,
            reqHeaders: this.reqHeaders,
            time: (0, now_1.default)(),
            method: this.method,
        });
        fetchResult
            .then(function (res) {
            res = res.clone();
            var type = getType(res.headers.get('Content-Type'));
            res.text().then(function (resTxt) {
                var data = {
                    type: type.type,
                    subType: type.subType,
                    time: (0, now_1.default)(),
                    size: getFetchSize(res, resTxt),
                    resTxt: resTxt,
                    resHeaders: getFetchHeaders(res),
                    status: res.status,
                };
                if (!(0, isEmpty_1.default)(_this.reqHeaders)) {
                    data.reqHeaders = _this.reqHeaders;
                }
                _this.emit('done', _this.id, data);
            });
            return res;
        })
            .catch(function (err) {
            _this.emit('error', _this.id, {
                errorText: err.message,
                time: (0, now_1.default)(),
            });
        });
    };
    return FetchRequest;
}(Emitter_1.default));
exports.FetchRequest = FetchRequest;
function getFetchSize(res, resTxt) {
    var size = 0;
    var contentLen = res.headers.get('Content-length');
    if (contentLen) {
        size = (0, toNum_1.default)(contentLen);
    }
    else {
        size = lenToUtf8Bytes(resTxt);
    }
    return size;
}
function getFetchHeaders(res) {
    var ret = {};
    res.headers.forEach(function (val, key) { return (ret[key] = val); });
    return ret;
}
function getHeaders(xhr) {
    var raw = xhr.getAllResponseHeaders();
    var lines = raw.split('\n');
    var ret = {};
    (0, each_1.default)(lines, function (line) {
        line = (0, trim_1.default)(line);
        if (line === '')
            return;
        var _a = line.split(':', 2), key = _a[0], val = _a[1];
        ret[key] = (0, trim_1.default)(val);
    });
    return ret;
}
function getSize(xhr, headersOnly, url) {
    var size = 0;
    function getStrSize() {
        if (!headersOnly) {
            var resType = xhr.responseType;
            var resTxt = '';
            if (resType === '' || resType === 'text')
                resTxt = xhr.responseText;
            if (resTxt)
                size = lenToUtf8Bytes(resTxt);
        }
    }
    if (isCrossOrig(url)) {
        getStrSize();
    }
    else {
        try {
            size = (0, toNum_1.default)(xhr.getResponseHeader('Content-Length'));
        }
        catch (e) {
            getStrSize();
        }
    }
    if (size === 0)
        getStrSize();
    return size;
}
var link = document.createElement('a');
function fullUrl(href) {
    link.href = href;
    return (link.protocol + '//' + link.host + link.pathname + link.search + link.hash);
}
function getFileName(url) {
    var ret = (0, last_1.default)(url.split('/'));
    if (ret.indexOf('?') > -1)
        ret = (0, trim_1.default)(ret.split('?')[0]);
    if (ret === '') {
        var urlObj = new Url_1.default(url);
        ret = urlObj.hostname;
    }
    return ret;
}
function getType(contentType) {
    if (!contentType)
        return {
            type: 'unknown',
            subType: 'unknown',
        };
    var type = contentType.split(';')[0].split('/');
    return {
        type: type[0],
        subType: (0, last_1.default)(type),
    };
}
function readBlobAsText(blob, callback) {
    var reader = new FileReader();
    reader.onload = function () {
        callback(null, reader.result);
    };
    reader.onerror = function (err) {
        callback(err);
    };
    reader.readAsText(blob);
}
var origin = window.location.origin;
function isCrossOrig(url) {
    return !(0, startWith_1.default)(url, origin);
}
function lenToUtf8Bytes(str) {
    var m = encodeURIComponent(str).match(/%[89ABab]/g);
    return str.length + (m ? m.length : 0);
}
